import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AppConfigService from '../service/AppConfigService';

export default class SuggestPopUp extends React.Component {

  static propTypes = {
    suggest: PropTypes.any.isRequired,
    onClick: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      showSuggest: false,
    }
  }

  onClick() {
    let isSearchResult = AppConfigService.isAperzaSearchResultPage();
    let isSearchNewsResult = AppConfigService.isAperzaSearchNewsResultPage();

    if (!isSearchResult && !isSearchNewsResult) {
      if (this.props.onClick) {
        this.props.onClick();
      }
      // let { showSuggest } = this.state;
      // this.setState({
      //   showSuggest: !showSuggest,
      // })
    }

  }

  onMouseOver(e) {
    //console.log('SuggestPopUp onMouseOver')
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    let { suggest } = this.props;
    let { showSuggest } = this.state;

    let isSearchResult = AppConfigService.isAperzaSearchResultPage();
    let isSearchNewsResult = AppConfigService.isAperzaSearchNewsResultPage();

    let suggestPopUpStyle = {
      display: showSuggest?'block':'none',
    };

    suggestPopUpStyle = {
      display: 'none'
    }

    return (
      <div className="suggest-popup" >
        <div className={classNames('suggest-popup-button',{inactive: showSuggest||isSearchResult||isSearchNewsResult})}
             onClick={::this.onClick}>
          <i className="fa fa-search" aria-hidden="true" />
        </div>
        <div className="suggest-popup-modal" style={suggestPopUpStyle} onMouseOver={::this.onMouseOver}>
          {suggest}
        </div>
      </div>
    )
  }

}